import { render, staticRenderFns } from "./EntgeltPage.vue?vue&type=template&id=1a3a7dcd&"
import script from "./EntgeltPage.vue?vue&type=script&lang=js&"
export * from "./EntgeltPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports